export enum DocumentType {
  Passport = 'passport',
  License = 'license',
  IdCard = 'idCard',
  Other = 'other',
}
